"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SCREEN_SIZES = exports.HOVER_ENABLED = exports.HOVER_DISABLED = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var HOVER_ENABLED = exports.HOVER_ENABLED = "@media (hover: hover) and (pointer: fine)";
var HOVER_DISABLED = exports.HOVER_DISABLED = "@media (pointer: coarse)";
var SCREEN_SIZES = exports.SCREEN_SIZES = {
  MOBILE: 640,
  DESKTOP: 1024
};
var BREAKPOINTS = {
  ON_MOBILE: "@media (max-width: ".concat(SCREEN_SIZES.MOBILE, "px)"),
  ABOVE_MOBILE: "@media (min-width: ".concat(SCREEN_SIZES.MOBILE + 1, "px)"),
  BELOW_DESKTOP: "@media (max-width: ".concat(SCREEN_SIZES.DESKTOP - 1, "px)"),
  ON_DESKTOP: "@media (min-width: ".concat(SCREEN_SIZES.DESKTOP, "px)")
};
var _default = exports.default = BREAKPOINTS;